export const INFO_PAGE_ID = 'info';

export const EVENT_DEFAULTS_PAGE_ID = 'event-defaults';

export const INTEGRATIONS_PAGE_ID = 'integrations';

export const USERS_PAGE_ID = 'users';

export const WIDGET_PAGE_ID = 'widget';

export const BILLING_PAGE_ID = 'billing';

export const VENUES_PAGE_ID = 'venues';
